import { z } from 'zod';
export const ACCOMMODATION_EXTRA_TIME_MAX_SEC = 14400;
/**
 * Per-student exam accommodations a proctor sets before the exam starts. Stored
 * at `quizzes/{quizId}/accommodations/{studentUid}` (admin SDK only) and
 * snapshotted onto the student's session when it is created.
 */
export const Accommodation = z.object({
    extraTimeSec: z.number().int().min(0).max(ACCOMMODATION_EXTRA_TIME_MAX_SEC).default(0),
    largeFont: z.boolean().default(false),
    highContrast: z.boolean().default(false),
    readAloud: z.boolean().default(false),
});
export function hasAccommodation(accommodation) {
    return accommodation.extraTimeSec > 0
        || accommodation.largeFont
        || accommodation.highContrast
        || accommodation.readAloud;
}
//# sourceMappingURL=accommodation.js.map